var React = require('react');

function Connections (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"stroke":"#333333"},React.createElement("g",{"transform":"translate(3.000000, 6.000000)"},[React.createElement("polyline",{"points":"13.7949711 0 17.5008534 0 17.5008534 3.70588235","key":0}),React.createElement("polyline",{"points":"17.4600772 0 9.80725339 7.65282386 6.72434048 4.56991095 0 11.2942514","key":1})]))));
}

Connections.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24"};

module.exports = Connections;

Connections.default = Connections;
